import {useMemo} from "react";
export const useAcfAboutUs = (acfFields) => {
    const acfAboutUs = useMemo(() => {
        const acf = {};
        const acfFilter = window.globalVars.definitons.filter(item => acfFields.includes(item.type));
        acfFilter.forEach(item => acf[item.type] = item.valueStr);
        return acf;
    }, []);

    return acfAboutUs
}


// WEBPACK FOOTER //
// ./src/hooks/useAcfAboutUs.js